
<template>
  <div id="emptyImageWrapper">
    <img id="nothingImage" src="@/assets/images/tap.png"/><br/>
    <p class="emptyText">Nothing selected yet, choose a step from Scenario section on the left.</p>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'Wait',
  data () {
    return {
      
    }
  },

  methods: {
   
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
  },
}
</script>

<style lang="scss" scoped>
  #emptyImageWrapper{
    text-align: center;
    margin-top:30px;
    color:#aaa;
  }
  #nothingImage{
    margin: 0 auto;
    max-width: 50px
  }
  .emptyText{
    margin-top:20px;
  }
</style>
